import { initializeApp, FirebaseApp } from 'firebase/app'
import { getAuth, Auth } from 'firebase/auth'
import { getStorage } from 'firebase/storage'
import { Translation } from '@/helpers'
import { FB_CONFIG } from '@/data'

let Firebase: FirebaseApp
let FirebaseStorage: ReturnType<typeof getStorage>
let FirebaseAuth: Auth

try {
    Firebase = initializeApp(FB_CONFIG)
    FirebaseStorage = getStorage(Firebase)
    FirebaseAuth = getAuth(Firebase)
}

catch (err: any) {
    if (!/already exists/.test(err.message)) {
        console.error(
            Translation('firebase-initialization-error'),
            err.stack
        )
    }
}

export {
    Firebase,
    FirebaseStorage,
    FirebaseAuth
}
